module.exports = __webpack_public_path__ + "static/about_system_vote-c8354c8b5ab3d6c8ded58d1e9459f2b1.png";